import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=f5956316&scoped=true"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"
import style0 from "./Expired.vue?vue&type=style&index=0&id=f5956316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5956316",
  null
  
)

export default component.exports